export enum CompanyUploadedDocumentsKeys {
    PHOTOS = 'photos',
    WALLS_IMAGES = 'walls',
    DOCS = 'docs'
}

export enum SocialNetworks {
    FACEBOOK = 'FACEBOOK',
    X = 'X',
    LINKEDIN = 'LINKEDIN',
    INSTAGRAM = 'INSTAGRAM',
    TIKTOK = 'TIKTOK',
    WEBSITE = 'WEBSITE',
    GITHUB = 'GITHUB',
    STACKOVERFLOW = 'STACKOVERFLOW',
    DRIBBLE = 'DRIBBLE',
    BEHANCE = 'BEHANCE',
    PRIVATE_LINK = 'private-link'
}